export enum ProductAttributeName {
  ARTIKELNUMMER = 'Artikelnummer',
  REBSORTEN = 'Rebsorten',
  FLASCHENGROSE = 'Flaschengröße',
  ANBAUREGION = 'Anbauregion',
  ANBAUGEBIET = 'Anbaugebiet',
  GEOGRAFISHE_HERKNUFT = 'geografische Herkunft',
  ALKOHOLGEHALT = 'Alkoholgehalt',
  RESTSUESSE = 'Restsüße',
  SAEUREGEHALT = 'Säuregehalt',
  ANSCHRIFT_HERSTELLER = 'Hersteller / Importeur',
}
